import {defineStore} from "pinia";
import {computed, ref} from "vue";

declare global {
  interface Window {
    user: any;
  }
}

export const useFilterStore = defineStore('filter', () => {
  const selectedFilter = ref<Set<string>>(new Set())
  const handleFilter = ref(0)

  const toggleFilter = (title: string, fireChange = true, force = false) => {
    if (fireChange) {
      handleFilter.value = handleFilter.value + 1
    }

    if (force) {
      selectedFilter.value.add(title)

      return
    }

    if (selectedFilter.value.has(title)) {
      selectedFilter.value.delete(title)

      return
    }

    selectedFilter.value.add(title)
  }

  const isChanged = computed(() => handleFilter.value)

  const isActive = (title: string) => selectedFilter.value.has(title)

  return {
    isChanged,
    toggleFilter,
    handleFilter,
    selectedFilter,
    isActive
  }
})
